import LanguageSelector from './LanguageSelector';
import LanguageSelectorSimple from './LanguageSelectorSimple';

LanguageSelector.Simple = LanguageSelectorSimple;

export default LanguageSelector;
